import React from "react";

export default function Loader() {
  return (
    <>
      <div className="loaderStyle">
        <div className="loader" id="loader-1"></div>
      </div>
    </>
  );
}
